import companyEnPages from './companyPages';
import cpnEnLang from './component';
import menuEnLang from './menu';
import pageEnLang from './pages';
import serverEnMessages from './serverMessages';
import exportEnColumns from './exportColumns';

const enLang = {
  ...serverEnMessages,
  ...exportEnColumns,
  ...pageEnLang,
  ...cpnEnLang,
  ...menuEnLang,
  ...companyEnPages,
  //base table
  'zTable.edit': 'Edit',
  'zTable.copy': 'copy',
  'zTable.delete': 'Delete',
  'zTable.actions': 'Actions',
  'zTable.search': 'Search',
  'zTable.reset': 'Reset',
  'zTable.records': 'Number of searches: ',
  'zTable.pageSize': 'Displayed results ',
  // roles
  UserName: 'Username',
  UserNameOrEmail: 'Email/ Account ID',
  User: 'User',
  EmailConfirmed: 'Email Confirmed',
  LockoutEnabled: 'Lockout Enabled',
  RoleUpdateTile: 'Role Update',
  RegisterUser: 'Register User',
  UpdateUser: 'Update User',
  CreateNewRole: 'Create New Role',
  UpdateNewRole: 'Update New Role',
  Password: 'Password',
  ConfirmPassword: 'Confirm Password',
  NameRole: 'Name',
  LoginButton: 'Login',
  ForgotPassword: 'Forgot password',
  // base
  createNew: 'Create new',
  save: 'Save',
  cancel: 'Cancel',
  VALIDATE_REQUIRED: 'Please fill out this field',
  Change_Password: 'Change password',
  Change_Layout: 'Change layout',
  Profile: 'Profile',
  SignOut: 'Sign out',
  Close: 'Close',
  Export: 'Export',
  Downloading: 'Downloading',
  'base.CreatedOn': 'Created on',
  'base.CreatedBy': 'Created by',
  'base.UpdatedOn': 'Updated on',
  'base.UpdatedBy': 'Updated by',
  'base.PhoneNumber': 'Phone number',
  'base.PhoneCode': 'Phone code',

  'base.Address': 'Address',
  'base.Country': 'Country',
  'base.Region': 'Region',
  'base.City': 'City',
  'base.Image': 'Image',
  'base.IpAddress': 'IP address',
  'base.Port': 'Port',
  'base.UserName': 'User Name',
  'base.Password': 'Password',
  'base.Method': 'Method',
  'base.Interface': 'Interface',
  'base.SSID': 'SSID',
  'base.SystemProvider': 'System provider',
  'base.SystemVersion': 'System version',
  'base.Encryption': 'Encryption',
  'base.DecryptionKey': 'Decryption Key',
  'base.EncryptionKey': 'Encryption Key',
  'base.Provider': 'Provider',
  'base.Provider2': 'Provider 2',
  'base.PayId': 'PayId',
  'base.PayId2': 'PayId2',
  'base.Controller': 'Controller',
  'base.DataType': 'Data type',
  'base.OwnPrivateKey': 'Own Private Key',
  'base.OrangePublicKey': 'Orange Public Key',
  'base.OperatorId': 'OperatorId',
  'base.AppId': 'AppId',
  'base.Active': 'Active',
  'base.SetActive': 'Set active',
  'base.SetInActive': 'Set inactive',
  'base.UpdateSucessMessage': 'Update successfull',
  'base.IsVerified': 'Is Verified',
  'base.Email': 'Email',
  'base.FullName': 'Full name',
  'base.DateOfBirth': 'Date of birth',
  'base.Married': 'Married',
  'base.Gender': 'Gender',
  'base.Company': 'Company',
  'base.Enabled': 'Enabled',
  'base.Description': 'Description',
  'base.From': 'From',
  'base.To': 'To',
  'base.Name': 'Name',
  'base.Value': 'Value',
  'base.IsActive': 'Is Active',
  'base.Code': 'Code',
  'base.IsStandard': 'Is Standard',
  'base.FirstName': 'First name',
  'base.LastName': 'Last name',
  'base.IPAddress': 'IP address',
  'base.Download': 'Download',
  'base.Export': 'Export',
  'base.Status': 'Status',
  'base.MarriedStatus': 'Married Status',
  // P4: tariff age limits.
  tariffAge_Column: 'Ages',
  tariffAge_MinAge: 'Minimum age (years)',
  tariffAge_MaxAge: 'Maximum age (years)',
  tariffAge_NoLimit: 'No limit',
  tariffAge_Help: 'Passenger age on the departure day, limits included (2 to 11: from age 2 until the day before turning 12). Empty: no limit. With a limit, the date of birth is required at sale and at modification.',
  tariffAge_None: '—',
  tariffAge_From: 'from {{min}}',
  tariffAge_UpTo: 'up to {{max}}',
  tariffAge_Between: '{{min}} to {{max}}',
  TariffAgeLimitsInvalid: 'Invalid age limits: between 0 and 120, minimum not above maximum.',
  passengerType_Title: 'Passenger type',
  passengerType_Adult: 'Adult',
  passengerType_Child: 'Child',
  passengerType_Infant: 'Infant',
  passengerType_Help: 'Adult, child or infant. A child or an infant always travels with an adult of the same booking. Student, military, senior… are adults (with an age limit on the company tariff if needed).',
  passengerType_ReadOnly: 'Set in the global tariff catalogue (super administrator).',
  tariffAgeIssues_ChildMustTravelWithAdult: 'Child without an adult',
  controlReviews_CategoryManual: "Offline typed ticket numbers",
  controlReviews_CategoryOnlineManual: "Online typed ticket numbers",
  controlReviews_flag_OnlineManualEntry: "Online typed ticket number",
  baggageReconciliation_WithoutTicket: "Baggage without ticket",
  baggageReconciliation_ToReview: "To review",
  baggageReconciliation_TotalHeld: "Total held",
  controlReviews_Title: "Offline controls and sales to review",
  controlReviews_Explanation: "Actions made without network, kept by the server but flagged: price gaps, boarding without control, inconsistent times, typed ticket numbers. Marking as reviewed changes neither the ticket nor the cash.",
  controlReviews_GapsByAgent: "Price gaps by driver",
  controlReviews_NoGaps: "No price gap to review.",
  controlReviews_None: "No flag to review.",
  controlReviews_IncludeReviewed: "Also show flags already reviewed",
  controlReviews_CategoryAll: "All flags",
  controlReviews_CategoryPriceGap: "Price gaps",
  controlReviews_CategoryBoarding: "Offline boarding without control",
  controlReviews_CategoryTime: "Inconsistent times",
  controlReviews_CategoryOther: "Other",
  controlReviews_Agent: "Agent",
  controlReviews_Count: "Count",
  controlReviews_Declared: "Declared amount",
  controlReviews_Expected: "Amount at fare",
  controlReviews_Gap: "Gap",
  controlReviews_SeeDetails: "See details",
  controlReviews_RecordedAt: "Date",
  controlReviews_Terminal: "Terminal",
  controlReviews_Ticket: "Ticket",
  controlReviews_Kind: "Action",
  controlReviews_KindCheckIn: "Check-in",
  controlReviews_KindBoarding: "Boarding",
  controlReviews_KindSale: "On-board sale",
  controlReviews_Flags: "Flags",
  controlReviews_Result: "Result",
  controlReviews_Kept: "Kept",
  controlReviews_Refused: "Refused",
  controlReviews_Review: "Review",
  controlReviews_ReviewedBy: "Reviewed by {{name}} on {{date}}",
  controlReviews_MarkReviewed: "Mark as reviewed",
  controlReviews_ConfirmReview: "Mark this flag as reviewed?",
  controlReviews_Reviewed: "Flag marked as reviewed",
  controlReviews_flag_PriceGap: "Price gap",
  controlReviews_flag_ManualEntry: "Typed ticket number",
  controlReviews_flag_NoKnownCheckIn: "Boarding without known control",
  controlReviews_flag_UnusedAtSync: "Received after \"unused\"",
  controlReviews_flag_DoubleUse: "Double use",
  controlReviews_flag_AfterBoardingClose: "After closing",
  controlReviews_flag_RevokedAfterControl: "Cancelled after control",
  controlReviews_flag_TerminalRevokedAfterControl: "Terminal revoked after control",
  controlReviews_flag_UnattestedTerminal: "Unattested terminal",
  controlReviews_flag_UntrustedClock: "Unreliable clock",
  controlReviews_flag_CounterTimeMismatch: "Time against counter",
  controlReviews_flag_ClockFarFromServer: "Time far from server",
  controlReviews_flag_ModifiedSincePrint: "Ticket changed since QR",
  controlReviews_flag_BaggageAmountGap: "Baggage gap",
  controlReviews_flag_BaggageOverLimit: "Baggage above maximum",
  controlReviews_flag_BaggageNotRecorded: "Baggage not recorded",
  tariffAgeIssues_Title: 'Offline sales to review: age and accompaniment',
  tariffAgeIssues_Explanation: 'Sales synchronised from a tablet or made on board offline, kept because already paid, whose tariff does not match the passenger age on the departure day (or without a date of birth for a limited tariff), or where a child travels without an adult of the booking. To fix a ticket, modify it (tariff change) from the cashier app, then mark the sale as reviewed.',
  tariffAgeIssues_IncludeReviewed: 'Also show reviewed sales',
  tariffAgeIssues_None: 'No mismatched sale to review.',
  tariffAgeIssues_Ticket: 'Ticket',
  tariffAgeIssues_Source: 'Source',
  tariffAgeIssues_SourceTablet: 'Tablet (offline)',
  tariffAgeIssues_SourceOnBoard: 'On board (offline)',
  tariffAgeIssues_Passenger: 'Passenger',
  tariffAgeIssues_BirthDate: 'Date of birth',
  tariffAgeIssues_Tariff: 'Tariff',
  tariffAgeIssues_Departure: 'Departure',
  tariffAgeIssues_Issue: 'Mismatch',
  tariffAgeIssues_TariffAgeOutOfRange: 'Age outside the tariff',
  tariffAgeIssues_TariffBirthDateRequired: 'Missing date of birth',
  tariffAgeIssues_SoldOn: 'Sold on',
  tariffAgeIssues_Review: 'Review',
  tariffAgeIssues_MarkReviewed: 'Mark reviewed',
  tariffAgeIssues_ConfirmReview: 'Mark this sale as reviewed? It will leave the list (still visible with reviewed sales).',
  tariffAgeIssues_Reviewed: 'Sale marked as reviewed.',
  tariffAgeIssues_ReviewedBy: 'Reviewed by {{name}} on {{date}}',
  registerReconciliation_CreditNotesIssued: 'Credit notes issued (non-cash)',
  registerReconciliation_CreditNotesIssuedValue: '{{count}} credit note(s) · {{amount}}',
  registerReconciliation_CreditNotesUsed: 'Credit notes used at sales (non-cash)',
  registerReconciliation_CreditNotesUsedValue: '{{count}} sale(s) · {{amount}}; returned to credit notes: {{returned}}',
  creditNotes_Title: 'Credit notes',
  creditNotes_Explanation: 'Company credit notes: issued by a ticket modification or cancellation, used at counter sales (fully or partly, never paid out in cash). An expired credit note can no longer be used. Read only.',
  creditNotes_AllStatuses: 'All credit notes',
  creditNotes_Status_active: 'Active',
  creditNotes_Status_partial: 'Partly used',
  creditNotes_Status_used: 'Used up',
  creditNotes_Status_expired: 'Expired',
  creditNotes_Status_cancelled: 'Cancelled',
  creditNotes_Number: 'Number',
  creditNotes_Holder: 'Holder',
  creditNotes_Phone: 'Phone',
  creditNotes_Amount: 'Amount',
  creditNotes_Balance: 'Balance',
  creditNotes_BalanceAfter: 'Balance after',
  creditNotes_IssuedOn: 'Issued on',
  creditNotes_IssuedBy: 'Issued by',
  creditNotes_ExpiresOn: 'Valid until',
  creditNotes_Status: 'Status',
  creditNotes_Uses: 'Uses',
  creditNotes_Detail: 'Details',
  creditNotes_DetailTitle: 'Credit note {{number}}',
  creditNotes_Search: 'Search',
  creditNotes_Totals: '{{count}} credit note(s) · issued {{amount}} · remaining balance {{balance}}',
  creditNotes_None: 'No credit note.',
  creditNotes_NoMovement: 'Not used yet.',
  creditNotes_IssuedFor: 'Issued for ticket(s)',
  creditNotes_Source: 'Original credit note (expired)',
  creditNotes_MovementOn: 'Date',
  creditNotes_MovementKind: 'Movement',
  creditNotes_Movement_use: 'Used at a sale',
  creditNotes_Movement_recredit: 'Returned (cancellation or modification)',
  creditNotes_Booking: 'Booking',
  creditNotes_Ticket: 'Ticket',
  creditNotes_By: 'By',
  registerReconciliation_CreditNotesHelp: 'Ticket modification refunds as credit notes since the last reconciliation: no cash out, not included in the cash totals.',
  'base.PassportNo': 'Passport No',
  'base.Nationality': 'Nationality',
  'base.DateOfIssue': 'Date of issue',
  'base.DateOfExpiry': 'Date of expiry',
  'base.CountryCode': 'Country code',
  'base.PlaceOfBirth': 'Place of birth',
  'base.Date': 'Date',
  'base.Amount': 'Amount',
  'base.CustomerName': 'Customer name',
  'base.Note': 'Note',
  'base.Cashier': 'Cashier',
  'base.Comment': 'Comment',
  'base.Close': 'Close',
  'base.Source': 'Source',
  'base.Destination': 'Destination',
  // Lot P3 : PIN de chef de gare, réimpressions.
  supervisorPin_Menu: "Station chief PIN",
  supervisorPin_Title: "Personal station chief PIN",
  supervisorPin_Explanation: "This 6-digit PIN is yours. You type it on the cashier's terminal, after choosing your name, to approve the 3rd reprint of a ticket (and upcoming sensitive operations). Never share it.",
  supervisorPin_NewPin: "New PIN (6 digits)",
  supervisorPin_ConfirmPin: "Confirm PIN",
  supervisorPin_SixDigits: "The PIN has exactly 6 digits.",
  supervisorPin_NotMatch: "The two PINs do not match.",
  supervisorPin_Saved: "Station chief PIN saved.",
  supervisorPin_Blocked: "Your PIN is blocked after 5 errors: choose a new one to unblock it.",
  supervisorPin_AlreadySet: "You already have a PIN: choosing a new one replaces it.",
  ticketReprints_Title: "Ticket reprints",
  ticketReprints_Column: "Reprints",
  ticketReprints_None: "No reprint.",
  ticketReprints_Date: "Date",
  ticketReprints_Cashier: "Cashier",
  ticketReprints_Terminal: "Terminal",
  ticketReprints_Register: "Register",
  ticketReprints_ApprovedBy: "Station chief",
  ticketModifications_Title: "Ticket modifications",
  ticketModifications_None: "No modification.",
  ticketModifications_Date: "Date",
  ticketModifications_Tickets: "Replaced ticket → new",
  ticketModifications_Changes: "Changes",
  ticketModifications_Difference: "Difference",
  ticketModifications_Fee: "Fee",
  ticketModifications_FeeWaived: "Waived",
  ticketModifications_CreditNote: "Credit note",
  ticketModifications_ModifiedBy: "Modified by",
  ticketModifications_Register: "Register",
  ticketModifications_ApprovedBy: "Approved by",
  ticketModifications_KindDeparture: "Departure",
  ticketModifications_KindSeat: "Seat",
  ticketModifications_KindTariff: "Fare",
  ticketModifications_KindName: "Name corrected",
  ticketModifications_KindTransfer: "Transfer",
  ticketModifications_KindHolder: "Contact details",
  ticketModifications_KindDestination: "Destination",
  seller_Register: "Register",
  seller_Cashier: "Cashier",
  companySettingsPage_PrintLanguage: "Print language",
  companySettingsPage_PrintLanguageHint: "Language of the tickets and receipts printed by the cashier app, whatever its screen language. Applied at the cashier's next sign-in.",
  resetPasswordPage_TitleInvitation: "Set my password",
  resetPasswordPage_InvitationHint: "Choose the password for your Prisme account. This link works only once.",
  salesReport_Modifications: "Ticket modifications",
  salesReport_NoModification: "No modification in this period.",
  salesReport_Date: "Date",
  salesReport_Booking: "Booking",
  salesReport_Tickets: "Replaced ticket → new",
  salesReport_Station: "Station",
  salesReport_Settlement: "Settlement",
  salesReport_Difference: "Difference",
  salesReport_TotalSales: "Sales",
  salesReport_TotalModifications: "Modifications",
  salesReport_TotalOutstanding: "Outstanding",
  salesReport_Settlement1: "None",
  salesReport_Settlement2: "Collected",
  salesReport_Settlement3: "Cash refund",
  salesReport_Settlement4: "Credit note",
  salesReport_Settlement5: "Wallet",
  salesReport_Settlement6: "Back to paying credit note",
  CurrentPasswordInvalid: "Current password is incorrect.",
  SupervisorPinMalformed: "The PIN has exactly 6 digits.",
  SupervisorPinNotStationSupervisor: "You are not administrator or supervisor of any station: no station chief PIN.",
  // Étape 5 (2026-11-02) : clés utilisées par le code et absentes des deux langues.
  cancellationPolicyPage_DuplicateDaysError: 'Duplicate days',
  'Additional Services': 'Additional services',
  Address: 'Address',
  'Are you sure want to delete this item?': 'Delete this item?',
  Cancel: 'Cancel',
  'Carrier Code': 'Carrier code',
  'Check All': 'Select all',
  'Columns Config': 'Columns',
  'Company Name': 'Company name',
  'Confirm password': 'Confirm password',
  Contains: 'Contains',
  Delete: 'Delete',
  Download: 'Download',
  'Email templates': 'E-mail templates',
  'Ends with': 'Ends with',
  Error: 'Error',
  Import: 'Import',
  InvalidLoginAttempt: 'The operation failed. Please try again.',
  Latitude: 'Latitude',
  LoginSessionExpiredContent: 'Your session has expired. Please sign in again.',
  LoginSessionExpiredTitle: 'Session expired',
  Longitude: 'Longitude',
  Name: 'Name',
  'Passenger Info': 'Passenger information',
  PasswordValidation: 'Please enter your password',
  'Pdf templates': 'PDF templates',
  'Profile image': 'Profile image',
  Reset: 'Reset',
  Save: 'Save',
  'Select date': 'Select date',
  'Starts with': 'Starts with',
  UserNameValidation: 'Please enter your user name or e-mail',
  Value: 'Value',
  close: 'Close',
  emailTemplate_Attachment_CultureCode: 'Language',
  // Étape 5 (2026-11-02) : textes écrits en dur dans les écrans, le texte anglais d'origine sert de clé.
  '(Kms)': '(km)',
  ALL: 'All',
  'Arrival trips': 'Arrivals',
  Available: 'Available',
  'Baggage Ref': 'Baggage ref.',
  'Baggage type': 'Baggage type',
  'Base Trip': 'Base trip',
  Basic: 'Basic',
  Before: 'Before',
  Bio: 'Bio',
  'Booking Ref': 'Booking ref.',
  'Bookings Amount': 'Bookings amount',
  'Brand Country': 'Brand country',
  'Brand Name': 'Brand name',
  'Brand Symbol': 'Brand symbol',
  Bus: 'Bus',
  'Bus No.': 'Bus no.',
  'Can not connect to printer': 'Cannot connect to the printer',
  'Cancelled Amount': 'Cancelled amount',
  'Cashier Booking': 'Counter bookings',
  'Character and number (ex: A01, A02)': 'Letter and number (e.g. A01, A02)',
  City: 'City',
  'Click Action': 'Click action',
  Companies: 'Companies',
  'Conflict ticket': 'Ticket in conflict',
  Country: 'Country',
  'Created on': 'Created on',
  'Date Departure': 'Departure date',
  'Departure Date': 'Departure date',
  'Departure time': 'Departure time',
  'Departure trips': 'Departures',
  'Discount Amount': 'Discount amount',
  'Do you want to cancel other trip?': 'Cancel the other trip?',
  'Document number': 'Document number',
  'End Date': 'End date',
  English: 'English',
  'Expense Detail': 'Expense details',
  'External Url': 'External URL',
  France: 'Français',
  'Free booked': 'Free booked',
  From: 'From',
  'From date': 'From',
  Hours: 'Hours',
  'Identity type': 'Identity document type',
  'Image URL': 'Image URL',
  Info: 'Info',
  'Is Active': 'Active',
  Map: 'Map',
  Mins: 'min',
  Minutes: 'Minutes',
  'Next 7 days': 'Next 7 days',
  'No. of Baggage': 'No. of baggage',
  'No. of Booking': 'No. of bookings',
  'No. of Bookings': 'No. of bookings',
  'No. of Bus': 'No. of buses',
  'No. of Passenger': 'No. of passengers',
  'No. of Passengers': 'No. of passengers',
  'No. of Shipment': 'No. of shipments',
  'No. of Ticket': 'No. of tickets',
  'No. of Trip': 'No. of trips',
  Note: 'Note',
  'Number and  character  (ex: 01A, 20A)': 'Number and letter (e.g. 01A, 20A)',
  'Number and ticket class   (ex: 01E, 40B)': 'Number and ticket class (e.g. 01E, 40B)',
  'Occupancy Rate': 'Occupancy rate',
  'Online Booking': 'Online bookings',
  'Only number (ex: 01, 02)': 'Number only (e.g. 01, 02)',
  Optional: 'Optional',
  Order: 'Order',
  'OutStanding Amount': 'Outstanding amount',
  'Over The Counters': 'Over the counter',
  'Passenger name and phone number': 'Passenger name and phone number',
  'Payment Details': 'Payment details',
  Region: 'Region',
  Report: 'Report',
  Revenue: 'Revenue',
  Route: 'Route',
  'Sales Report Ticket Details': 'Sales report ticket details',
  'Schedule Passengers': 'Scheduled passengers',
  Screen: 'Screen',
  'Seat Color': 'Seat colour',
  'Select export method': 'Export method',
  'Select other seat': 'Choose another seat',
  'Select route': 'Select a route',
  'Sell On The Go Passengers': 'Sell-on-the-go passengers',
  'Sell station': 'Selling station',
  'Selling Assignment': 'Selling assignment',
  'Send report to email successfully!': 'Report sent by e-mail.',
  'Send verifycation code successfull!': 'Verification code sent.',
  'Shipment, Tickets & Baggage Details': 'Shipments, tickets and baggage',
  'Shipments Handled': 'Shipments handled',
  'Some seats do not have ticket class or seat name!': 'Some seats have no ticket class or seat name',
  'Some seats do not have ticket class or seat name. Do you want to save this data?': 'Some seats have no ticket class or seat name. Save anyway?',
  'Start Date': 'Start date',
  'Start date': 'Start date',
  'Starting character': 'Starting letter',
  'Starting number': 'Starting number',
  'Ticket Sold': 'Tickets sold',
  'Ticket amount': 'Ticket amount',
  'Ticket class and number (ex: E01, B02)': 'Ticket class and number (e.g. E01, B02)',
  'Ticket type': 'Ticket type',
  Title: 'Title',
  'To Date': 'To',
  'Toilet left': 'Toilet (left)',
  'Toilet right': 'Toilet (right)',
  'Total Seats': 'Total seats',
  'Trip Name': 'Trip',
  'Trip map': 'Trip map',
  'Trip name': 'Trip',
  Type: 'Type',
  'Update Success!': 'Updated.',
  'Update success': 'Updated.',
  'Upload video': 'Upload video',
  'Video Thumbnail Url': 'Video thumbnail URL',
  'Video Url': 'Video URL',
  Year: 'Year',
  Yes: 'Yes',
  hours: 'hours',
  tripCompanyId: 'Trip company',
  'Trips Report': 'Trips report',
  'Trip Details Report': 'Trip details report',
  'Trip Income Report': 'Trip income report',
  'Sale With Group Report': 'Sales by group',
  'Sales Report': 'Sales report',
  'Trip Status': 'Trip status',
  'Un Earned Revenue Report': 'Unearned revenue report',
  'Company Roles': 'Company roles',
  'Manage templates': 'Templates',
  'Passenger App Advertising': 'Passenger app advertising',
  'Sell on the go bookings': 'Sell-on-the-go bookings',
  Distance: 'Distance',
  Date: 'Date',
  External: 'External',
  WithDraw: 'Withdrawal',
  Ready: 'Ready',
  Closed: 'Closed',
  Booked: 'Booked',
  Selected: 'Selected',
  Blocked: 'Blocked',
  Partner: 'Partner',
  Online: 'Online',
  Tickets: 'Tickets',
  Shipments: 'Shipments',
  Expenses: 'Expenses',
  Bagages: 'Baggage',
  Adult: 'Adult',
  Child: 'Child',
  Infant: 'Infant',
  Expense: 'Expense',
  Seat: 'Seat',
  Door: 'Door',
  Fridge: 'Fridge',
  Submit: 'Save',
  Confirm: 'Confirm',
  Source: 'Origin',
  Destination: 'Destination',
  Station: 'Station',
  Amount: 'Amount',
  Trip: 'Trip',
  Recurrence: 'Recurrence',
  // Étape 5 (2026-11-02) : valeurs des listes déroulantes (constants.ts, __getSelectOptions), clé « enum.<Valeur> ».
  'enum.Oui': 'Yes',
  'enum.Non': 'No',
  'enum.None': 'None',
  'enum.LinkToTripDetail': 'Trip details',
  'enum.ExternalUrl': 'External link',
  'enum.Image': 'Image',
  'enum.Video': 'Video',
  'enum.BeforeLogin': 'Before login',
  'enum.Home': 'Home',
  'enum.Slider': 'Slider',
  'enum.StaticPanel': 'Static panel',
  'enum.Payment': 'Payment',
  'enum.CashInCashOut': 'Cash in / cash out',
  'enum.Sms': 'SMS',
  'enum.Email': 'E-mail',
  'enum.SmsAndEmail': 'SMS and e-mail',
  'enum.Sunday': 'Sunday',
  'enum.Monday': 'Monday',
  'enum.Tuesday': 'Tuesday',
  'enum.Wednesday': 'Wednesday',
  'enum.Thursday': 'Thursday',
  'enum.Friday': 'Friday',
  'enum.Saturday': 'Saturday',
  'enum.PassengerMobile': 'Passenger app (mobile)',
  'enum.PassengerWeb': 'Passenger website',
  'enum.Passenger': 'Passenger',
  'enum.TicketClass': 'Ticket class',
  'enum.TariffParameter': 'Fare',
  'enum.AllCompanies': 'All companies',
  'enum.CustomCompanies': 'Selected companies',
  'enum.Shipment': 'Shipment',
  'enum.Baggage': 'Baggage',
  'enum.Trip': 'Trip',
  'enum.OneTime': 'Once',
  'enum.MultipleTimes': 'Several times',
  'enum.NewUsers': 'New users',
  'enum.OldUsers': 'Existing users',
  'enum.AllUsers': 'All users',
  'enum.CustomUsers': 'Selected users',
  'enum.FixedValue': 'Fixed amount',
  'enum.PercentageBase': 'Percentage',
  'enum.Employee': 'Employee',
  'enum.ExternalUser': 'External user',
  'enum.NationalIdentityCard': 'National identity card',
  'enum.Passport': 'Passport',
  'enum.Cash': 'Cash',
  'enum.MobileMoney': 'Mobile money',
  'enum.CreditCard': 'Credit card',
  'enum.Miles': 'Miles',
  'enum.Credit': 'Credit',
  'enum.Wallet': 'Wallet',
  'enum.CreditNote': 'Credit note',
  'enum.Bank': 'Bank',
  'enum.PrePaid': 'Prepaid',
  'enum.PostPaid': 'Postpaid',
  'enum.First': 'First',
  'enum.Default': 'Default',
  'enum.Paid': 'Paid',
  'enum.Extension': 'Extension',
  'enum.Receipts': 'Receipts',
  'enum.Tags': 'Labels',
  'enum.Deposit': 'Deposit',
  'enum.Withdraw': 'Withdrawal',
  'enum.Ready': 'Ready',
  'enum.Open': 'Open',
  'enum.Closed': 'Closed',
  'enum.International': 'International',
  'enum.National': 'National',
  'enum.Increase': 'Increase',
  'enum.Decrease': 'Decrease',
  'enum.Percentage': 'Percentage',
  'enum.Merchant': 'Merchant',
  'enum.TransportCompanies': 'Transport companies',
  'enum.Customer': 'Customer',
  'enum.Operators': 'Operators',
  'enum.Merchants': 'Merchants',
  'enum.Companies': 'Companies',
  'enum.Issued': 'Issued',
  'enum.CheckedIn': 'Checked in',
  'enum.Cancelled': 'Cancelled',
  'enum.Pending': 'Pending',
  'enum.Expired': 'Expired',
  'enum.UnUsed': 'Unused',
  'enum.Boarded': 'Boarded',
  'enum.Waiting': 'Waiting',
  'enum.Free': 'Free',
  'enum.CancelRequested': 'Cancellation requested',
  'enum.DidNotAnswer': 'Did not answer',
  'enum.AskedToCallBack': 'Asked to call back',
  'enum.Positive': 'Positive',
  'enum.Negative': 'Negative',
  'enum.Moderate': 'Neutral',
  'enum.NotUsingApp': 'Not using the app',
  'enum.Upload': 'Upload',
  'enum.Youtube': 'YouTube',
  'enum.OneWay': 'One way',
  'enum.Return': 'Return',
  'enum.Male': 'Male',
  'enum.Female': 'Female',
  salesReport_StationGroup: 'Selling station: {{station}} – {{count}} lines',
  'Back Home': 'Back to home',
  'Export PDF': 'Export PDF',
  'Export Excel': 'Export Excel',
  'Toilet Right': 'Toilet (right)',
  'Generate seat name': 'Generate seat names',
  'Log Reconciliation': 'Record reconciliation',
  'Only Departure trips': 'Departures only',
  'Only Arrival trips': 'Arrivals only',
  'Toggle full screen': 'Full screen',
  'Manage Roles': 'Manage roles',
};

export default enLang;
